export default __webpack_public_path__ + "static/dumpster1-9d8dcb00778a231a7798a6400afd8eac.png";